
import filterSitemap from "../defaults/filter.ts";


const { lazy } = require('react');

function populate(source) {
  const results = [];

  source.forEach(item => {
    const title = item.section;
    const [result] = results.filter(m => m.title === title);

    if (result) {
      result.links.push(item);
    } else {
      results.push({
        title,
        links: [item],
      });
    }
  });

  return results;
}


export default filterSitemap({ "general": {
      "title": "General",
      "sections": [...populate([
  {
    id: "introduction",
    route: "/general/introduction",
    title: "Introduction",
    link: "/general/introduction",
    section: "General",
    meta: {"title":"Introduction","section":"General"},
    page: lazy(() => import('../tools/__generated__/general-introduction.tsx')),
  }])],
    },"docs": {
      "title": "Documentation",
      "sections": [...populate([
  {
    id: "01-articles",
    route: "/docs/01-articles",
    title: "Introduction",
    link: "/docs/01-articles",
    section: "General",
    meta: {"title":"Introduction","section":"General"},
    page: lazy(() => import('../tools/__generated__/tutorials-01-articles.tsx')),
  }, 
  {
    id: "02-samples",
    route: "/docs/02-samples",
    title: "Samples",
    link: "/docs/02-samples",
    section: "General",
    meta: {"title":"Samples","section":"General"},
    page: lazy(() => import('../tools/__generated__/tutorials-02-samples.tsx')),
  }])],
    },"blog": {
      "title": "Blog",
      "sections": [...populate([
  {
    id: "2026-08-01-anglesharp-js-v100-release",
    route: "/blog/2026-08-01-anglesharp-js-v100-release",
    title: "AngleSharp.Js 1.0.0",
    link: "/blog/2026-08-01-anglesharp-js-v100-release",
    section: "Posts",
    meta: {"title":"AngleSharp.Js 1.0.0","date":"2026-08-01 13:15:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2026-08-01-anglesharp-js-v100-release.tsx')),
  }, 
  {
    id: "2026-07-27-anglesharp-v160",
    route: "/blog/2026-07-27-anglesharp-v160",
    title: "AngleSharp 1.6.0",
    link: "/blog/2026-07-27-anglesharp-v160",
    section: "Posts",
    meta: {"title":"AngleSharp 1.6.0","date":"2026-07-27 00:15:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2026-07-27-anglesharp-v160.tsx')),
  }, 
  {
    id: "2026-07-25-anglesharp-css-v1",
    route: "/blog/2026-07-25-anglesharp-css-v1",
    title: "AngleSharp.Css 1.0.0",
    link: "/blog/2026-07-25-anglesharp-css-v1",
    section: "Posts",
    meta: {"title":"AngleSharp.Css 1.0.0","date":"2026-07-25 17:10:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2026-07-25-anglesharp-css-v1.tsx')),
  }, 
  {
    id: "2020-03-13-anglesharp-v0140",
    route: "/blog/2020-03-13-anglesharp-v0140",
    title: "AngleSharp v0.14.0",
    link: "/blog/2020-03-13-anglesharp-v0140",
    section: "Posts",
    meta: {"title":"AngleSharp v0.14.0","date":"2020-03-13 07:13:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2020-03-13-anglesharp-v0140.tsx')),
  }, 
  {
    id: "2019-05-15-anglesharp-v0121",
    route: "/blog/2019-05-15-anglesharp-v0121",
    title: "AngleSharp v0.12.1",
    link: "/blog/2019-05-15-anglesharp-v0121",
    section: "Posts",
    meta: {"title":"AngleSharp v0.12.1","date":"2019-05-15 12:52:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2019-05-15-anglesharp-v0121.tsx')),
  }, 
  {
    id: "2019-05-06-anglesharp-v012-forward",
    route: "/blog/2019-05-06-anglesharp-v012-forward",
    title: "AngleSharp v0.12 and the future",
    link: "/blog/2019-05-06-anglesharp-v012-forward",
    section: "Posts",
    meta: {"title":"AngleSharp v0.12 and the future","date":"2019-05-06 22:23:10","categories":"news organization release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2019-05-06-anglesharp-v012-forward.tsx')),
  }, 
  {
    id: "2019-05-02-dotnet-foundation",
    route: "/blog/2019-05-02-dotnet-foundation",
    title: "Joining the .NET Foundation",
    link: "/blog/2019-05-02-dotnet-foundation",
    section: "Posts",
    meta: {"title":"Joining the .NET Foundation","date":"2019-05-02 15:00:00","categories":"news organization release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2019-05-02-dotnet-foundation.tsx')),
  }, 
  {
    id: "2019-02-12-anglesharp-v011-released",
    route: "/blog/2019-02-12-anglesharp-v011-released",
    title: "AngleSharp v0.11.0 released",
    link: "/blog/2019-02-12-anglesharp-v011-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.11.0 released","date":"2019-02-12 09:20:00","categories":"news release major","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2019-02-12-anglesharp-v011-released.tsx')),
  }, 
  {
    id: "2019-01-06-anglesharp-v010-released",
    route: "/blog/2019-01-06-anglesharp-v010-released",
    title: "AngleSharp v0.10.0 released",
    link: "/blog/2019-01-06-anglesharp-v010-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.10.0 released","date":"2019-01-06 10:49:00","categories":"news release major","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2019-01-06-anglesharp-v010-released.tsx')),
  }, 
  {
    id: "2018-03-09-taking-anglesharp-to-the-next-level",
    route: "/blog/2018-03-09-taking-anglesharp-to-the-next-level",
    title: "Taking AngleSharp to the Next Level",
    link: "/blog/2018-03-09-taking-anglesharp-to-the-next-level",
    section: "Posts",
    meta: {"title":"Taking AngleSharp to the Next Level","date":"2018-03-09 10:15:00","categories":"news organization","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2018-03-09-taking-anglesharp-to-the-next-level.tsx')),
  }, 
  {
    id: "2018-01-03-anglesharp-v099-released",
    route: "/blog/2018-01-03-anglesharp-v099-released",
    title: "AngleSharp v0.9.9.1 released",
    link: "/blog/2018-01-03-anglesharp-v099-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.9.9.1 released","date":"2018-01-03 16:01:00","categories":"news release hotfix","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2018-01-03-anglesharp-v099-released.tsx')),
  }, 
  {
    id: "2016-10-03-anglesharp-scripting-v050-released",
    route: "/blog/2016-10-03-anglesharp-scripting-v050-released",
    title: "AngleSharp Scripting v0.5.0 released",
    link: "/blog/2016-10-03-anglesharp-scripting-v050-released",
    section: "Posts",
    meta: {"title":"AngleSharp Scripting v0.5.0 released","date":"2016-10-03 11:45:00","categories":"news release scripting","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2016-10-03-anglesharp-scripting-v050-released.tsx')),
  }, 
  {
    id: "2016-09-04-anglesharp-v098-released",
    route: "/blog/2016-09-04-anglesharp-v098-released",
    title: "AngleSharp v0.9.8 released",
    link: "/blog/2016-09-04-anglesharp-v098-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.9.8 released","date":"2016-09-04 17:40:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2016-09-04-anglesharp-v098-released.tsx')),
  }, 
  {
    id: "2016-07-16-anglesharp-v97-released",
    route: "/blog/2016-07-16-anglesharp-v97-released",
    title: "AngleSharp v0.9.7 released",
    link: "/blog/2016-07-16-anglesharp-v97-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.9.7 released","date":"2016-07-16 22:20:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2016-07-16-anglesharp-v97-released.tsx')),
  }, 
  {
    id: "2016-05-06-anglesharp-v96-released",
    route: "/blog/2016-05-06-anglesharp-v96-released",
    title: "AngleSharp v0.9.6 released",
    link: "/blog/2016-05-06-anglesharp-v96-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.9.6 released","date":"2016-05-06 13:27:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2016-05-06-anglesharp-v96-released.tsx')),
  }, 
  {
    id: "2016-03-17-anglesharp-v95-released",
    route: "/blog/2016-03-17-anglesharp-v95-released",
    title: "AngleSharp v0.9.5 released",
    link: "/blog/2016-03-17-anglesharp-v95-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.9.5 released","date":"2016-03-17 14:44:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2016-03-17-anglesharp-v95-released.tsx')),
  }, 
  {
    id: "2015-12-31-anglesharp-v094-released",
    route: "/blog/2015-12-31-anglesharp-v094-released",
    title: "AngleSharp v0.9.4 released",
    link: "/blog/2015-12-31-anglesharp-v094-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.9.4 released","date":"2015-12-31 08:36:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2015-12-31-anglesharp-v094-released.tsx')),
  }, 
  {
    id: "2015-10-12-anglesharp-v093-released",
    route: "/blog/2015-10-12-anglesharp-v093-released",
    title: "AngleSharp v0.9.3 released",
    link: "/blog/2015-10-12-anglesharp-v093-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.9.3 released","date":"2015-10-12 11:44:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2015-10-12-anglesharp-v093-released.tsx')),
  }, 
  {
    id: "2015-10-04-anglesharp-io",
    route: "/blog/2015-10-04-anglesharp-io",
    title: "AngleSharp IO",
    link: "/blog/2015-10-04-anglesharp-io",
    section: "Posts",
    meta: {"title":"AngleSharp IO","date":"2015-10-04 23:34:00","categories":"news project","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2015-10-04-anglesharp-io.tsx')),
  }, 
  {
    id: "2015-09-24-anglesharp-v092-released",
    route: "/blog/2015-09-24-anglesharp-v092-released",
    title: "AngleSharp v0.9.2 released",
    link: "/blog/2015-09-24-anglesharp-v092-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.9.2 released","date":"2015-09-24 23:44:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2015-09-24-anglesharp-v092-released.tsx')),
  }, 
  {
    id: "2015-09-16-anglesharp-v091-released",
    route: "/blog/2015-09-16-anglesharp-v091-released",
    title: "AngleSharp v0.9.1 released",
    link: "/blog/2015-09-16-anglesharp-v091-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.9.1 released","date":"2015-09-16 11:08:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2015-09-16-anglesharp-v091-released.tsx')),
  }, 
  {
    id: "2015-08-29-anglesharp-documentation",
    route: "/blog/2015-08-29-anglesharp-documentation",
    title: "AngleSharp Documentation",
    link: "/blog/2015-08-29-anglesharp-documentation",
    section: "Posts",
    meta: {"title":"AngleSharp Documentation","date":"2015-08-29 10:01:00","categories":"information documentation","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2015-08-29-anglesharp-documentation.tsx')),
  }, 
  {
    id: "2015-08-27-anglesharp-v09-released",
    route: "/blog/2015-08-27-anglesharp-v09-released",
    title: "AngleSharp v0.9 released",
    link: "/blog/2015-08-27-anglesharp-v09-released",
    section: "Posts",
    meta: {"title":"AngleSharp v0.9 released","date":"2015-08-27 14:05:00","categories":"news release","author":"Florian Rappl","userId":"FlorianRappl","section":"Posts"},
    page: lazy(() => import('../tools/__generated__/blog-2015-08-27-anglesharp-v09-released.tsx')),
  }])],
    },"projects": {
      "title": "Projects",
      "sections": [...populate([
  {
    id: "Overview",
    route: "/projects/Overview",
    title: "Overview",
    link: "/projects/Overview",
    section: "General",
    meta: {"title":"Overview","section":"General"},
    page: lazy(() => import('../tools/__generated__/projects-Overview.tsx')),
  }])],
    } });
